import one from '../assets/png/aff/one.png'
import two from '../assets/png/aff/two.png'
import three from '../assets/png/aff/three.png'
import four from '../assets/png/aff/four.png'
import five from '../assets/png/aff/five.png'

export const achievementData = {
    achievements : [
        {
            id : 1,
            title : 'Convener',
            details : 'Astrophilia',
            date : 'Sept 2022- Present',
            field : 'Student Club',
            image : one
        },
        {
            id : 2,
            title : 'Student Member',
            details : 'American Physical Society (APS Physics)',
            date : 'Oct 2022- Present',
            field : 'Organisation',
            image : two
        },
        {
            id : 3,
            title : 'Technical Domain Member',
            details : 'Google Developer Student Clubs SRM',
            date : 'Oct 2022- Present',
            field : 'Student Club',
            image : three
        },
        {
            id : 4,
            title : 'Member in Competitive Programming Domain',
            details : 'Codechef SRM Student Chapter',
            date : 'Nov 2021- Present',
            field : 'Student Club',
            image : four
        },
        {
            id : 5,
            title : 'Member in AI & ML Domain',
            details : 'Team Envision, Aaruush',
            date : 'Sept 2021- Oct 2022',
            field : 'Student Club',
            image : five
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/